import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Timer } from "lucide-react";
import { useLang } from "../i18n";

const TARGET = new Date("2027-01-01T00:00:00");

const labels = {
  it: { title: "Conto alla rovescia ICO · 1 gennaio 2027", d: "Giorni", h: "Ore", m: "Min", s: "Sec", live: "ICO in corso" },
  en: { title: "ICO countdown · 1 January 2027", d: "Days", h: "Hours", m: "Min", s: "Sec", live: "ICO live" },
};

const line = {
  hidden: { y: "115%" },
  show: (i) => ({
    y: "0%",
    transition: { duration: 0.9, delay: 0.1 + i * 0.15, ease: [0.22, 1, 0.36, 1] },
  }),
};

function getRemaining() {
  const ms = TARGET - new Date();
  const done = ms <= 0;
  let delta = Math.max(0, Math.floor(ms / 1000));
  const days = Math.floor(delta / 86400);
  delta -= days * 86400;
  const hours = Math.floor(delta / 3600);
  delta -= hours * 3600;
  const minutes = Math.floor(delta / 60);
  const seconds = delta - minutes * 60;
  return { days, hours, minutes, seconds, done };
}

export default function HomeTitle() {
  const { lang, t } = useLang();
  const l = labels[lang] || labels.it;
  const [cd, setCd] = useState(getRemaining());

  useEffect(() => {
    const id = setInterval(() => setCd(getRemaining()), 1000);
    return () => clearInterval(id);
  }, []);

  const units = [
    { v: cd.days, label: l.d },
    { v: cd.hours, label: l.h },
    { v: cd.minutes, label: l.m },
    { v: cd.seconds, label: l.s },
  ];

  return (
    <section data-testid="home-title" className="pt-32 sm:pt-36 pb-2">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div data-testid="ico-countdown" className="flex flex-col items-start">
          <a
            href="#pionieri"
            data-testid="countdown-ico-link"
            className="inline-flex items-center gap-2 font-mono text-[11px] sm:text-xs uppercase tracking-[0.18em] text-sky-700 hover:text-sky-500 transition-colors"
          >
            <Timer size={14} />
            {cd.done ? l.live : l.title}
          </a>
          <div className="mt-3 flex items-stretch gap-2 sm:gap-3">
            {units.map((u) => (
              <div
                key={u.label}
                data-testid={`countdown-${u.label.toLowerCase()}`}
                className="min-w-[58px] sm:min-w-[72px] rounded-xl border border-sky-200 bg-white/80 px-2.5 py-2 text-center shadow-sm"
              >
                <p className="font-mono text-2xl sm:text-3xl font-bold text-slate-900 tabular-nums leading-none">
                  {String(u.v).padStart(2, "0")}
                </p>
                <p className="mt-1.5 font-mono text-[9px] sm:text-[10px] uppercase tracking-[0.15em] text-slate-500">
                  {u.label}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 text-center">
          <h1 className="font-display font-extrabold tracking-tight text-slate-900 text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
            <span className="block overflow-hidden pb-2">
              <motion.span custom={0} variants={line} initial="hidden" animate="show" className="block">
                {t.home.title}
              </motion.span>
            </span>
          </h1>
        </div>
      </div>
    </section>
  );
}
